import { render, staticRenderFns } from "./hqglBaseComputerSetting.vue?vue&type=template&id=b03780d8&scoped=true&"
import script from "./hqglBaseComputerSetting.vue?vue&type=script&lang=js&"
export * from "./hqglBaseComputerSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b03780d8",
  null
  
)

export default component.exports